<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        <i class="mdi mdi-file-tree"></i>
        회사정보
    </h4>
</div>

<div class="modal-body">
    <div dtg-manage-company-list
        [listType]="DtgListType.modal"
        (outCompanyInfo)="callbackSelectCompany($event)"></div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        취소
    </button>
</div>